/**
 * Card number input used for adding a card
 *
 * Dependent on getCardSpecs() from https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js,
 * but you could just supply an object of specifications similar to what getCardSpecs returns.
 */
import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { StyleSheet, css } from 'aphrodite';
import TextInput from 'react-text-input';

import { cardSpecsPropType, cardSpecPropType } from 'prop-validators';
import { defaultCardSpec, getSpecificCardSpec } from '../utility/card-utils';

const STYLES = StyleSheet.create({
	logoWrapper: {
		height: '100%',
		position: 'absolute',
		top: 0,
		right: 0
	},
	dropdown: {
		padding: 0,
		textIndent: 12,
		boxSizing: 'content-box',
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none',
		'@-moz-document url-prefix()': {
			textIndent: 2.5,
		},
		'::-ms-expand': { display: 'none' },
	},
	arrow: {
		position: 'absolute',
		right: 10,
		top: 20,
		cursor: 'default',
		pointerEvents: 'none'
	},
	logo: {
		display: 'inline-block',
		marginTop: 12,
		marginRight: 2
	},
	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out',
		marginRight: -2,
		color: 'rgb(0, 0, 0)'
	},
	errorStylesSelect: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0
	}
});

class CardType extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			cardType: '',
			cardTypeErrorMessage: '',
			showIsRequiredError: false,
			cardType: this.props.cardType || '',
		};
	}

	/*
	* Format card typepes into array
	*/
	formatCardTypes = (cardTypes = []) => {
		return Object.keys(cardTypes).map((key) => {
			const { name, type } = cardTypes[key] || {};
			return { key, name, type }
		})
	}

	/*
	* Handle card type change
	*/
	handleChange = (event) => {
		const { cardSpecs: {cardTypes = {}} } = this.props
		let cardType = event.target.value;
		this.setState({ cardType });

		Object.keys(cardTypes).map((key) => {
			const { name, type } = cardTypes[key] || {};
			if (cardType === type) {
				this.props.changeCardType(cardTypes[key]);
			}
		})
	}

	render() {
		const {country, cardSpecs: { cardTypes = {}}, errorMessage} = this.props
		let { cardTypeErrorMessage } = this.state;
		let errorMessageClassNames = classNames(css(STYLES.errorMessage), {
			'vx_form-control-message': errorMessage || cardTypeErrorMessage
		});
		let errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage || cardTypeErrorMessage) {
			errorStyles = { height: '100%' };
		}

		// Removing card type 'SWITCH' for GB
		if (country === 'GB'){
			delete cardTypes.SWITCH
		}

		return (
			<div className={classNames({
				'vx_has-error-with-message': errorMessage,
				'vx_has-error': errorMessage,
				})} style={{ margin: '10px 2px 0 0', position: 'relative' }}>
					<div style={{ position: 'relative', marginTop: 0 }}>
						<select id="cardTypeSelection"
							className={classNames(
								'vx_form-control',
								'vx_form-control_complex',
								`${css(STYLES.dropdown)}`,
								`${errorMessage ? css(STYLES.errorStylesSelect) : ''}`
							)}
							value={this.state.cardType}
							onChange={this.handleChange}>
							<option value="" disabled>{this.props.label}</option>
							{this.formatCardTypes(cardTypes).map((item) => (
								<option key={item.key} value={item.type}>{item.name}</option>
							))}
						</select>
						{!errorMessage && <label htmlFor="cardTypeSelection" className={`icon icon-arrow-down-small ${css(STYLES.arrow)}`}></label>}

						<span className="vx_selectIcon_error"></span>

						{/* show the error message if it exists */}
						<div className={errorMessageClassNames} style={errorStyles}>{errorMessage || cardTypeErrorMessage}</div>
					</div>
					
					
			</div>
		)
	}
};

CardType.propTypes = {
	changeCardType: PropTypes.func.isRequired
};

export { defaultCardSpec };
export default CardType;



// WEBPACK FOOTER //
// ./components/card-type.js